// extracted by mini-css-extract-plugin
module.exports = {"component":"DataReloader_component__207No"};